import React, { useState } from 'react';
import EducationMaterialFolder from './EducationMaterialFolder';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import Loading from '../Loading';
import { EDUCATION_MATERIAL_FOLDERS_WITH_USER_MATERIALS } from './EducationMaterialData';
import netteApiClient from '../../Services/NetteApiClient';
import { useHealthPlanContext } from '../../Services/HealthPlanContext';
//@ts-ignore
import styles from './EducationMaterialLibrary.module.scss';
import useHealthPlan from '../../Modules/HealthPlan/Hooks/useHealthPlan';
import useTranslation from '../../Hooks/useTranslation';
import { updateHealthPlanUserItem } from '../../Modules/HealthPlan/Services/healthPlan.service';

interface EducationMaterialLibraryProps {
	savingButton: boolean;
	afterSave?: string;
	onSuccess?: any;
	patientId?: string;
	CustomHeaderComponent?: React.FC;
}

const EducationMaterialLibrary: React.FC<EducationMaterialLibraryProps> = ({
	savingButton,
	afterSave,
	patientId,
	onSuccess,
	CustomHeaderComponent,
}) => {
	const [folders, setFolders] = useState([]);
	const { t } = useTranslation();
	const { healthPlanUser, activeHealthPlanUserItem, refetchHealthPlanUser } =
		useHealthPlanContext();
	const [initialized, setInitialized] = useState(false);
	const { isBaby, isDiabetes } = useHealthPlan();

	const updateItem = item => {
		const currentFolders = [...folders];
		for (const folderIndex in currentFolders) {
			if (currentFolders[folderIndex].id === item.id) {
				currentFolders[folderIndex] = item;
			}
		}

		setFolders(currentFolders);
	};

	const getModuleName = () => {
		if (isBaby) {
			return 'BABY';
		}
		if (isDiabetes) {
			return 'DIABETES';
		}
	};

	// @ts-ignore
	useEffectAsync(async () => {
		if (!healthPlanUser) {
			await refetchHealthPlanUser();
		} else {
			setInitialized(true);
		}
	}, [folders, healthPlanUser]);

	useEffectAsync(async () => {}, []);

	// @ts-ignore
	const loadData = async () => {
		setInitialized(false);
		const result = await apiClient.graphql({
			query: EDUCATION_MATERIAL_FOLDERS_WITH_USER_MATERIALS,
			variables: {
				module: getModuleName(),
				patientId,
			},
			fetchPolicy: 'network-only',
		});

		const seenMaterials = {};
		for (const material of result?.data?.educationMaterials?.data ?? []) {
			seenMaterials[material.id] = material.seen;
		}

		const currentFolders = result?.data?.educationMaterialFolders?.data.map(
			d => ({
				...d,
				educationMaterials: d.educationMaterials.map(e => ({
					...e,
					active:
						activeHealthPlanUserItem?.extra?.data.length > 0
							? activeHealthPlanUserItem?.extra?.data.find(m => m.key === e.key)
							: null,
					seen: seenMaterials[e.id] || false,
					sent: typeof seenMaterials[e.id] !== 'undefined',
				})),
			}),
		);

		setFolders(currentFolders);
	};

	// @ts-ignore
	useEffectAsync(async () => {
		await loadData();
	});

	const handleSave = async () => {
		const activeMaterials: { key: string }[] = [];
		const itemsForDiscourse: { id: string; type: string }[] = [];
		folders?.map(folder => {
			folder?.educationMaterials?.map((material: any) => {
				if (material.active) {
					activeMaterials.push({
						key: material.key,
					});
					itemsForDiscourse.push({
						id: material.id,
						type: 'educationMaterial',
					});
				}
				return material;
			});
			return folder;
		});

		if (healthPlanUser?.healthPlanId && activeHealthPlanUserItem?.id) {
			await updateHealthPlanUserItem({
				healthPlanId: healthPlanUser.healthPlanId,
				healthPlanUserId: healthPlanUser.id,
				healthPlanItemId: activeHealthPlanUserItem.id,
				data: {
					extra: {
						data: activeMaterials,
					},
				},
			});
			onSuccess?.();
		}

		if (afterSave) {
			await netteApiClient.get(afterSave);
		}
		if (onSuccess) {
			onSuccess();
		}
	};

	if (!initialized) {
		return (
			<div className={'py-5'}>
				<Loading />
			</div>
		);
	}

	return (
		initialized && (
			<div className={styles.wrapper}>
				{CustomHeaderComponent && <CustomHeaderComponent />}
				{folders.map((folder, index) => (
					<div key={index}>
						<EducationMaterialFolder data={folder} onUpdateItem={updateItem} />
					</div>
				))}
				{savingButton && (
					<div className='d-flex flex-row align-items-center justify-content-end mt-4'>
						<a
							className='btn btn-green-global remastered mt-3 mr-3 px-5'
							onClick={handleSave}>
							{t('base.shared.save')}
						</a>
					</div>
				)}
			</div>
		)
	);
};

export default EducationMaterialLibrary;
